import { ACCESS, GSK_PHARMA_ID, SERVICES } from "../../../../configs/constants";
import { Button, Dropdown, Icon, Menu } from "antd";
import AuthRender from "../../../../containers/AuthRender";
import React from "react";
import { connect } from "react-redux";
import {
  exportData,
  exportGainData,
  exportRaw,
  mailCommandeReassort,
  mailSampleParodontax,
  mailGainAdvil,
  mailVisitRelevePharma
} from "../../actions/stats";
import {
  getCompareMode,
  getCurrentFilterObj,
  getCurrentSummaryData,
  getKpiSelected,
  getSummaryDimensions,
  getSummaryKpiSelected,
  getTableLoading
} from "../../selectors";
import Excel from "exceljs";
import FileSaver from "file-saver";
import CoreFilters from "../../core/filters";
import { mapping as dimensionsMapping } from "./../../summary/dimensions";
import { currentClientSelector } from "../../../../redux/selectors/auth";
import moment from "moment-timezone";
import { isStartDateRef } from "../../utils";
import { kpis as KPIS } from "../../../../configs/kpis";

let DIMENSION_INFOS = {};
const setDimensionInfos = (clientInfos = {}) => {
  let pdc_label = [{ id: "pdc_id", label: "PDC ID" }];
  let pdc_id = [
    {
      id: "pdc_label",
      label: "PDC"
    }
  ];
  if (clientInfos.id === 17) {
    pdc_label.push({ id: "pdc_cip", label: "PDC CIP" });
    pdc_id.push({ id: "pdc_cip", label: "PDC CIP" });
  }

  DIMENSION_INFOS = {
    pdc_label,
    pdc_id,
    product_ean: [{ id: "product_ean", label: "EAN" }],
    retailer_label: [{ id: "retailer_id", label: "RETAILER ID" }]
  };
};
const getDimensionLabel = dimensionId => {
  const dim = dimensionsMapping.find(v => v.id === dimensionId) || {};
  return dim.label || "";
};
const getDimensions = (
  dataset,
  dimensions,
  level = 0,
  currentLevel = 0,
  currentDimensions = [],
  dimensionInfos = []
) => {
  if (currentLevel > level) return [];

  if (level === currentLevel) {
    const line = [];
    for (let i = 0; i < dimensions.length; i++) {
      const dimension = dimensions[i] || "";

      //add additional infos
      const infos = DIMENSION_INFOS[dimension] || [];
      for (let j = 0; j < infos.length; j++) {
        const info = infos[j] || {};
        if (currentDimensions[i]) {
          line.push(dimensionInfos[info.id]);
        } else {
          line.push("");
        }
      }

      if (currentDimensions[i]) {
        const currentDimension = currentDimensions[i];
        line.push(currentDimension);
      } else {
        line.push("Total");
      }
    }

    if (dataset.format === "%") {
      line.push(dataset.value / 100);
    } else {
      line.push(dataset.value);
    }

    if (dataset.format === "%" || dataset.format === "/" || dataset.format === "weight") {
      line.push(dataset.v === null ? "" : dataset.v);
      line.push(dataset.n === null ? "" : dataset.n);
    }

    if (dataset.p1) {
      if (dataset.p1.format === "%") {
        line.push(dataset.p1.value / 100);
      } else {
        line.push(dataset.p1.value);
      }

      if (dataset.p1.format === "%" || dataset.p1.format === "/" || dataset.p1.format === "weight") {
        line.push(dataset.p1.v === null ? "" : dataset.p1.v);
        line.push(dataset.p1.n === null ? "" : dataset.p1.n);
      }
    }
    if (dataset.diff) {
      if (dataset.format === "%") {
        line.push(dataset.diff.value / 100);
      } else {
        line.push(dataset.diff.value);
      }
    }

    return [line];
  }

  const data = dataset.data;
  if (data && data.length > 0) {
    const dims = [];
    for (let i = 0; i < data.length; i++) {
      const datum = data[i];
      const dimInfos = datum.dim_infos || {};
      dimensionInfos = { ...dimensionInfos, ...dimInfos };
      const dimensionLabel = datum.dim_value || "Non renseigné";
      const dimData = getDimensions(
        datum,
        dimensions,
        level,
        currentLevel + 1,
        [...currentDimensions, dimensionLabel],
        dimensionInfos
      );
      if (dimData) {
        for (let j = 0; j < dimData.length; j++) {
          const dimDatum = dimData[j];
          dims.push(dimDatum);
        }
      }
    }

    if (dims.length > 0 && currentLevel > 0 && currentLevel === level - 1) {
      const line = [];
      //add sub total
      for (let i = 0; i < dimensions.length; i++) {
        const dimension = dimensions[i];
        //add additional infos
        const infos = DIMENSION_INFOS[dimension] || [];
        for (let j = 0; j < infos.length; j++) {
          const info = infos[j] || {};
          if (currentDimensions[i]) {
            line.push(dimensionInfos[info.id]);
          } else {
            line.push("");
          }
        }

        if (currentDimensions[i]) {
          line.push(currentDimensions[i]);
        } else {
          line.push("Total");
        }
      }

      if (dataset.format === "%") {
        line.push(dataset.value / 100);
      } else {
        line.push(dataset.value);
      }

      if (dataset.format === "%" || dataset.format === "/" || dataset.format === "weight") {
        line.push(dataset.v === null ? "" : dataset.v);
        line.push(dataset.n === null ? "" : dataset.n);
      }

      if (dataset.p1) {
        if (dataset.p1.format === "%") {
          line.push(dataset.p1.value / 100);
        } else {
          line.push(dataset.p1.value);
        }

        if (dataset.p1.format === "%" || dataset.p1.format === "/" || dataset.p1.format === "weight") {
          line.push(dataset.p1.v === null ? "" : dataset.p1.v);
          line.push(dataset.p1.n === null ? "" : dataset.p1.n);
        }
      }
      if (dataset.diff) {
        if (dataset.format === "%") {
          line.push(dataset.diff.value / 100);
        } else {
          line.push(dataset.diff.value);
        }
      }
      dims.unshift(line);
      dims.unshift([]);
    }

    return dims;
  }
  return [];
};

export const periodToTitle = (period = []) => {
  const startDate = moment(period[0]) || moment();
  const endDate = moment(period[1]) || moment();

  if (isStartDateRef(startDate)) {
    return `${endDate.format("DD/MM/YYYY")}`;
  } else {
    return `Période du ${startDate.format("DD/MM/YYYY") || ""} au ${endDate.format("DD/MM/YYYY") || ""}`;
  }
};

export const periodToCellTitle = (period = []) => {
  const startDate = moment(period[0]) || moment();
  const endDate = moment(period[1]) || moment();

  if (isStartDateRef(startDate)) {
    return `${endDate.format("DD/MM/YYYY")}`;
  } else {
    return `${startDate.format("DD/MM/YYYY") || ""} - ${endDate.format("DD/MM/YYYY") || ""}`;
  }
};

/**
 * Add filters data to xlsx
 * @param worksheet
 * @param filters
 * @param period
 */
const addFiltersToXLSX = (worksheet, filters, period, period1, compare = false) => {
  const values = CoreFilters.getValues(filters, period);
  const valuesKeys = Object.keys(values);
  values["period"] = values["period"] || {};
  //worksheet.addRow([`Période du ${values["period"].start || ""} au ${values["period"].end || ""}`]);
  worksheet.addRow([periodToTitle(period)]);

  if (compare) {
    const values1 = CoreFilters.getValues(filters, period1);
    values1["period"] = values1["period"] || {};
    //worksheet.addRow([`Période du ${values1["period"].start || ""} au ${values1["period"].end || ""}`]);
    worksheet.addRow([periodToTitle(period1)]);
  }

  delete values["period"];
  for (let i = 0; i < valuesKeys.length; i++) {
    const valuesKey = valuesKeys[i];
    const valueElts = values[valuesKey] || [];

    for (let j = 0; j < valueElts.length; j++) {
      //add header
      if (j === 0) {
        worksheet.addRow([valuesKey]);
        worksheet.getRow(worksheet.rowCount).font = { bold: true };
      }
      const valueElt = valueElts[j];
      //add value
      worksheet.addRow([valueElt]);

      //add footer
      if (j === valueElts.length - 1) {
        worksheet.addRow([""]);
      }
    }
  }
};
const getRowsXLSX = (data = [], dimensions = []) => {
  return [
    ...getDimensions(data, dimensions, 0),
    ...getDimensions(data, dimensions, 1),
    ...getDimensions(data, dimensions, 2),
    ...getDimensions(data, dimensions, 3),
    ...getDimensions(data, dimensions, 4)
  ];
};
const exportTable = ({
  data = {},
  dimensions = [],
  kpi = {},
  filters = [],
  period = [],
  period1 = [],
  compare = false
}) => {
  //if (!data.n) return;

  //get data
  const columns = [];
  for (let i = 0; i < dimensions.length; i++) {
    const dimension = dimensions[i];
    //add infos label
    const infos = DIMENSION_INFOS[dimension] || [];
    for (let j = 0; j < infos.length; j++) {
      const info = infos[j] || {};
      columns.push({
        key: info.id + "j",
        header: info.label
      });
    }

    columns.push({
      key: i,
      header: getDimensionLabel(dimension)
    });
  }

  let nbDimsLabels = columns.length;
  columns.push({
    key: columns.length,
    header: "Valeur"
  });
  if (data.format === "%" || data.format === "/" || data.format === "weight") {
    columns.push({
      key: columns.length,
      header: "Nombre"
    });
    columns.push({
      key: columns.length,
      header: "Total"
    });
  }

  if (compare) {
    columns.push({
      key: columns.length,
      header: "Valeur"
    });
    if (data.format === "%" || data.format === "/" || data.format === "weight") {
      columns.push({
        key: columns.length,
        header: "Nombre"
      });
      columns.push({
        key: columns.length,
        header: "Total"
      });
    }
    columns.push({
      key: columns.length,

      header: "Gain"
    });
  }

  const rows = getRowsXLSX(data, dimensions);

  if (compare) {
    const pCellTitle = periodToCellTitle(period);
    const p1CellTitle = periodToCellTitle(period1);
    let dateRow = Array(nbDimsLabels).fill("", 0, nbDimsLabels);
    dateRow = [...dateRow, pCellTitle, "", "", p1CellTitle, ""];
    rows.unshift(dateRow);
  }

  let workbook = new Excel.Workbook();
  workbook.creator = "EFFICIENCE SELL";
  workbook.created = new Date();

  let worksheet = workbook.addWorksheet("Données", {
    views: [{ ySplit: 1 }]
  });

  worksheet.columns = columns;
  worksheet.addRows(rows);

  if (compare) {
    worksheet.mergeCells(2, nbDimsLabels + 1, 2, nbDimsLabels + 3);
    worksheet.mergeCells(2, nbDimsLabels + 4, 2, nbDimsLabels + 6);

    worksheet.getRow(2).alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true
    };
  }

  //add style
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  };
  worksheet.alignment = { vertical: "middle", horizontal: "center" };

  //format to %

  for (let i = 0; i < columns.length; i++) {
    const column = columns[i];
    if (column.header === "Valeur" || column.header === "Gain") {
      if (data.format === "%") {
        worksheet.getColumn(i + 1).numFmt = "0.0%";
      } else if (data.format === "/") {
        worksheet.getColumn(i + 1).numFmt = "0.0";
      }
    }
  }

  //add filters
  let worksheetFilter = workbook.addWorksheet("Filtres");
  worksheetFilter.columns = [
    {
      key: 0,
      header: "Filtres"
    }
  ];
  worksheetFilter.getRow(1).font = { bold: true };
  addFiltersToXLSX(worksheetFilter, filters, period, period1, compare);

  let filename = kpi.long_label || "";
  workbook.xlsx
    .writeBuffer()
    .then(buffer => FileSaver.saveAs(new Blob([buffer]), `${filename}.xlsx`))
    .catch(err => console.log("Error writing excel export", err));
};

const Export = props => {
  const { period, tableLoading, dimensions, currentClient, style, mailCommandeReassort, exportData } = props;
  if (tableLoading) return null;
  const isGlobalDimension = !!(dimensions && dimensions[0] === "global");
  setDimensionInfos(currentClient);
  const propsStyle = style || {};
  return (
    <AuthRender service={SERVICES.Statistiques} access={ACCESS.export}>
      <Dropdown
        overlay={
          <Menu
            onClick={({ key }) => {
              if (key === "full") {
                exportData();
              } else if (key === "gainfull") {
                props.exportGainData();
              } else if (key === "raw") {
                props.exportRaw();
              } else if (key === "commandreassort") {
                mailCommandeReassort(period);
              } else if (key === "sampleparodontax") {
                props.mailSampleParodontax();
              } else if (key === "advil") {
                props.mailGainAdvil(period);
              } else if (key === "relevevisit") {
                props.mailVisitRelevePharma(period);
              } else {
                exportTable(props);
              }
            }}
          >
            {!isGlobalDimension && (
              <Menu.Item key="cross">
                <Icon type="download" /> Données affichées
              </Menu.Item>
            )}
            <Menu.Item key="full">
              <Icon type="download" /> Données complètes
            </Menu.Item>
            {currentClient &&
              currentClient.id === 5 &&
              props.mainKpi &&
              props.mainKpi.id === KPIS.DN &&
              !props.compare && (
                <Menu.Item key="gainfull">
                  <Icon type="download" /> Gain par visite
                </Menu.Item>
              )}
            {currentClient &&
              currentClient.id === GSK_PHARMA_ID &&
              props.mainKpi &&
              props.mainKpi.id === KPIS.CMD_REASSORT_KPI_ID && (
                <Menu.Item key="commandreassort">
                  <Icon type="mail" /> {`Mail de commande de reassort (${periodToTitle(period)})`}
                </Menu.Item>
              )}
            {currentClient &&
              currentClient.id === GSK_PHARMA_ID &&
              props.mainKpi &&
              props.mainKpi.id === KPIS.SAMPLE_PARODONTAX_KPI_ID && (
                <Menu.Item key="sampleparodontax">
                  <Icon type="mail" /> Mail échantillon parodontax
                </Menu.Item>
              )}
            {currentClient && currentClient.id === GSK_PHARMA_ID && (
              <Menu.Item key="advil">
                <Icon type="mail" /> {`Mail gain facing ADVIL  (${periodToTitle(period)})`}
              </Menu.Item>
            )}
            {currentClient && currentClient.id === GSK_PHARMA_ID && (
              <Menu.Item key="relevevisit">
                <Icon type="mail" /> {`Mail releve visite (${periodToTitle(period)})`}
              </Menu.Item>
            )}
            {props.mainKpi &&
              //props.mainKpi.id === KPIS.VISITES &&
              !props.compare && (
                <Menu.Item key="raw">
                  <Icon type="download" /> Données brutes
                </Menu.Item>
              )}
          </Menu>
        }
      >
        <Button style={{ color: "white", float: "right", ...propsStyle }} type="primary" size={"default"}>
          Exporter
        </Button>
      </Dropdown>
    </AuthRender>
  );
};
const mapStateToProps = state => {
  const stats = state.stats || {};
  return {
    tableLoading: getTableLoading(state),
    dimensions: getSummaryDimensions(state),
    data: getCurrentSummaryData(state),
    kpi: getSummaryKpiSelected(state),
    mainKpi: getKpiSelected(state),
    period: stats.period || [],
    period1: stats.periodToCompare || [],
    filters: getCurrentFilterObj(state),
    currentClient: currentClientSelector(state),
    compare: getCompareMode(state)
  };
};

export default connect(mapStateToProps, {
  exportData,
  exportGainData,
  exportRaw,
  mailCommandeReassort,
  mailSampleParodontax,
  mailGainAdvil,
  mailVisitRelevePharma
})(Export);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Export.js